export default "__VITE_ASSET__a0816951__"